// extracted by mini-css-extract-plugin
module.exports = {"link":"FooterItem_link__NZwVl"};